import React from 'react';
import { FinancialDashboard as FinancialDashboardComponent } from '@/components/financial/FinancialDashboard';

export default function FinancialDashboard() {
  return (
    <div className="p-6">
      <FinancialDashboardComponent />
    </div>
  );
}